<template>
    <!-- <div class="ft-notification"> -->
        <b-row>
        <div class="alert-col">
            <b-alert show :variant="variant" class="ft-alert" style="display: flex;flex-direction: row; align-items: flex-start;">
                <!-- <b-icon icon="check" aria-hidden="true" v-if="isBtIcon"></b-icon> -->
                <!-- <b-icon icon="exclamation-circle"></b-icon> -->
                <icon-base v-if="icon" width="24" height="24" viewBox="0 0 24 24">

                    <component v-bind:is="icon"></component>
                </icon-base>
                <div class="alert-content" style="">
                    <p>{{content}}
                    <span class="ft-route-time small-text grey-text-1">{{subText}}</span>
                    </p>
                </div>
                <div style="position: absolute; right: 1rem; top: 2px">
                    <component v-bind="data" :item="data" :is="actionType" ></component>
                </div>
            </b-alert>
        </div>
        </b-row>
    <!-- </div> -->
</template>

<script>
import IconBase from './IconBase.vue'
import IconAlertExpire from './icons/IconAlertExpire.vue'
import IconAlertTick from './icons/IconAlertTick.vue'
import IconAlertCancelled from './icons/IconAlertCancelled.vue'
import IconAlertLostBid from './icons/IconAlertLostBid.vue'
import IconAlertWonBid from './icons/IconAlertWonBid.vue'
import IconInfoCircle from './icons/IconInfoCircle.vue'
// import { BIconCheck } from 'bootstrap-vue'
// import { BIconCheck } from 'bootstrap-vue'

import AddSupplierModal from '../components/AddSupplierModal.vue'
import CallUsLink from './CallUsLink.vue'

import config from '../config/config'
import moment from 'moment'


const TimeSlot = {
    props: {
        item: Object
    },
    render(h) {
        return h('div', {style: {"font-size": "14px","line-height": "20px","color": "#707070"} }, moment(this.$attrs.bid_placed_at || new Date()).fromNow())
        // return (<div style="font-size: 14px;line-height: 20px;color: #707070;">{{this.item}}</div>)
    }
}

export default {
    props: {
        data: Object
    },
    components: {
        IconBase,
        IconAlertExpire,
        IconAlertTick,
        IconAlertCancelled,
        IconAlertLostBid,
        IconAlertWonBid,
        IconInfoCircle,
        AddSupplierModal,
        CallUsLink,
        TimeSlot,
        // BIconCheck
    },
    data() {
        return {
            stats_banner: config.demand_status,
            variant: '',
            content: '',
            subText: '',
            // actionType: '',
            icon: null,
            isBtIcon: false
        }
    },
    watch: {
        $route(to, from) {
            if (to.params.lang != from.params.lang) {
                this.bannerContent()
            }
        }
    },
    computed: {
        bidPlacedAt: function () {
            return moment(this.data.bid_placed_at || new Date()).fromNow()
        },
        actionType: function() {
            let actionComponent = ""
            switch (this.data.demand_status_details.status) {
                case 'OPEN':
                    if (this.data.demand_status_details.rate == null && this.data.demand_status_details.trucks_supplied == null) {
                        actionComponent = AddSupplierModal
                    } else {
                        // actionComponent = TimeSlot
                    }
                    break;
                case 'EXPIRED':
                    actionComponent = CallUsLink
                    break;
                case 'CANCELLED':
                    break;
                case 'PLACED':
                    if (this.data.demand_status_details.rate != null && this.data.demand_status_details.trucks_supplied != null && this.data.demand_status_details.winning_bid != null) {
                       actionComponent = ""
                    } else if (this.data.demand_status_details.rate != null && this.data.demand_status_details.trucks_supplied != null && this.data.demand_status_details.winning_bid == null) {
                        actionComponent = CallUsLink
                    }
                    break;
                default:
                    actionComponent = AddSupplierModal
                    break;
            }

            return actionComponent
        }
    },
    methods: {
        bannerContent() {
            this.isBtIcon = false
            const {data} = this
            const status = data.demand_status_details.is_edit_allowed ? 'EDIT' : data.demand_status_details.status
            switch (status) {
                case 'OPEN':
                    if (data.demand_status_details.rate == null && data.demand_status_details.trucks_supplied == null) {
                        this.variant = 'warning text-wrapper'
                        this.content = this.$t('message.banner.bannerActiveText', [data.supplier_name])
                        // this.actionType = AddSupplierModal
                        this.icon = null
                    } else {
                        this.variant = 'success'
                        this.content =  this.$t('message.banner.bannerSuccessText', [`${data.demand_status_details.trucks_supplied} x ${this.data.demand_status_details.rate}`])
                        // this.actionType = TimeSlot
                        this.icon = IconAlertTick
                        this.isBtIcon = true
                    }
                    break;
                case 'EXPIRED':
                    this.variant = 'danger'
                    this.content = this.$t('message.banner.bannerExpiredText')
                    // this.actionType = CallUsLink
                    this.icon = IconAlertExpire
                    break;
                case 'CANCELLED':
                    this.variant = 'secondary'
                    this.content = this.$t('message.banner.bannerCancelledText')
                    this.icon = IconAlertCancelled
                    break;
                case 'PLACED':
                    if (data.demand_status_details.rate != null && data.demand_status_details.trucks_supplied != null && data.demand_status_details.winning_bid != null) {
                        this.variant = 'danger'
                        this.content = this.$t('message.banner.bannerLostBidText', [data.demand_status_details.winning_bid.rate])
                        this.subText = this.$t('message.banner.bannerLostBidText2', [data.demand_status_details.winning_bid.rate - data.demand_status_details.rate])
                        this.icon = IconAlertLostBid
                    } else if (data.demand_status_details.rate != null && data.demand_status_details.trucks_supplied != null && data.demand_status_details.winning_bid == null) {
                        this.variant = 'success'
                        this.content = this.$t('message.banner.bannerWonBidText')
                        // this.actionType = CallUsLink
                        this.icon = IconAlertWonBid
                    }
                    break;
                case 'EDIT':
                    this.variant = 'warning'
                    this.content = this.$t('message.banner.bannerEditBidText', [data.demand_status_details.lowest_bid.rate])
                    this.subText = this.$t('message.banner.bannerEditBidText2')
                    this.icon = IconInfoCircle
                    break;
                default:
                    this.variant = 'warning'
                    this.content = this.$t('message.banner.bannerActiveText', [data.supplier_name])
                    this.icon = null
                    break;
            }

        }
    },
    mounted() {
        this.bannerContent()
    }
}
</script>

<style lang="scss">
    .alert-col {
        width: 100%;
    }
</style>
